import React, {useEffect} from 'react';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Box from '@material-ui/core/Box';
import PolicyRecordDetails from './PolicyRecordDetails';
import PolicyHistory from './PolicyHistory';
import {useDispatch} from 'react-redux';
import {getPolicyRecord} from 'ApplicationEntry/ducks/policyRecord';
import {ValidApplication, InvalidApplication} from 'ApplicationEntry/models/Application';
import './PolicyDetailsTab.sass';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const {children, value, index, ...other} = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`awd-policy-information-tabpanel-${index}`}
      aria-labelledby={`awd-policy-information-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: any) {
  return {
    id: `awd-policy-information-tab-${index}`,
    'aria-controls': `awd-policy-information-tabpanel-${index}`,
  };
}

type PolicyDetailsProps = {
  application: ValidApplication | InvalidApplication;
};

export default function PolicyDetailsTab(props: PolicyDetailsProps) {
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
  };
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPolicyRecord());
  }, [dispatch]);

  return (
    <div className="policy-details-tab">
      <AppBar position="static">
        <Tabs value={value} onChange={handleChange} aria-label="AWD Policy Information Tab">
          <Tab label="AWD - Policy Record Details" {...a11yProps(0)} />
          <Tab label="AWD - Policy History" {...a11yProps(1)} />
        </Tabs>
      </AppBar>
      <div className="policy-record-container">
        <TabPanel value={value} index={0}>
          <PolicyRecordDetails policyRecord={props.application.policyRecord} />
        </TabPanel>
      </div>
      <div className="policy-history-container">
        <TabPanel value={value} index={1}>
          <PolicyHistory />
        </TabPanel>
      </div>
    </div>
  );
}
